import { useEffect } from "react";

/*
  Minimal SEO hook — sets <title>, meta description, meta keywords, and
  og:title / og:description / og:url on the current document. No external
  library needed. Restores previous values when the component unmounts so
  navigating between routes always shows the right page metadata.
*/

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSEO = ({ title, description, keywords, canonical }) => {
  useEffect(() => {
    const prev = {
      title: document.title,
    };
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    if (canonical) {
      setMeta("og:url", canonical, "property");
      setCanonical(canonical);
    }
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    return () => {
      document.title = prev.title;
    };
  }, [title, description, keywords, canonical]);
};

export default useSEO;
